import * as React from "react";
import SortableList, { SortableItemModel } from "components/SortableList/SortableList";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import { DataBaseComponent, DataBaseComponentState } from "components/DataBaseComponent/DataBaseComponent";

interface StepSorterProps {
    title: string;
    initialItems: SortableItemModel[];
    stepId?: string;
    onComplete(ordered: SortableItemModel[]): void;
}

interface StepSorterState extends DataBaseComponentState {
    items: SortableItemModel[];
}

class StepSorter extends DataBaseComponent<StepSorterProps, StepSorterState> {
    constructor(props: StepSorterProps) {
        super(props);
        this.state = {
            items: [...this.props.initialItems],
        };
    }

    async save() {
        if (this.state.items) {
            this.props.onComplete(this.state.items);
        }

        return true;
    }

    render() {
        const steps = this.state.items;
        return (
            <SaveDialogLayout title={this.props.title} busy={this.state.busy} errors={this.errors} onSaveClick={() => this.save()} saveButtonLabel="Done">
                {steps && <SortableList onOrderChanged={this.stepsOrderChanged} items={this.state.items} />}
            </SaveDialogLayout>
        );
    }

    private stepsOrderChanged = (items: SortableItemModel[]) => {
        this.setState({ items });
    };
}

export default StepSorter;
